module.exports = __webpack_public_path__ + "static/media/mwg2__.67dc1fdf.svg";